export function getDeviceLocation() {
  return new Promise((resolve, reject) => {
    if (!!window?.ReactNativeWebView) {
      window.handleGetLocation = function (data) {
        resolve(data)
      }
      window.ReactNativeWebView.postMessage(JSON.stringify({ eventName: 'GET_LOCATION' }))
    } else {
      if (!window.nsWebViewInterface) {
        return reject('Mobile framework is not initialized yet')
      }
      window.nsWebViewInterface.on('responseGeolocationData', (data) => resolve(data))
      window.nsWebViewInterface.emit('requestGeolocationData', {})
    }
  })
}
